export class Logger {
  private name: string

  constructor (name) {
    if (name.includes('/')) {
      name = name.split('/')
      name = name[name.length - 1]
      if (name.endsWith('.js') || name.endsWith('.ts')) {
        name = name.substring(0, name.length - 3)
      }
    }
    this.name = name
  }

  doLog (level, ...args) {
    console[level](`%c[${this.name}]`, 'color: #aaa', ...args)
  }

  debug (...args) {
    this.doLog('debug', ...args)
  }

  log (...args) {
    this.doLog('log', ...args)
  }

  warn (...args) {
    this.doLog('warn', ...args)
  }

  info (...args) {
    this.doLog('info', ...args)
  }

  error (...args) {
    this.doLog('error', ...args)
  }

  exception (...args) {
    this.doLog('exception', ...args)
  }

  group (...args) {
    this.doLog('group', ...args)
  }

  groupEnd (...args) {
    this.doLog('groupEnd', ...args)
  }
}
